// extracted by mini-css-extract-plugin
export default {"one_btn_popup":"OneBtnPopup_one_btn_popup__4Gp7P","title":"OneBtnPopup_title__qzSAW","subtitle":"OneBtnPopup_subtitle__t7dV-","button_box":"OneBtnPopup_button_box__PTuUp"};